import { useTranslation } from "react-i18next";
import { Link, Typography } from "@mui/material";
import { WORDPRESS_URL } from "@constants";

export const BroadbandInfo = () => {
    const { t } = useTranslation("confirmation");

    return (
        <Typography color="secondary" variant="normal">
            {t("provideBroadbandInfo")}
            <Link
                color="primary"
                href={`${WORDPRESS_URL}/cancel-previous-broadband`}
                rel="noopener"
                target="_blank"
                underline="always"
            >
                {t("yourDetails")}.
            </Link>
        </Typography>
    );
};
